// extracted by mini-css-extract-plugin
export default {"CardsPanelActivityList":"R28U9rztn1K6SVnxzq9w","CardsPanelActivity__clickableRow":"bzPBvTTTreY9ke9eLJe_"};